import Vue from 'vue';
import VueRouter from 'vue-router';
import {mapState} from 'vuex';
import './RegisterProjectComponents';
Vue.use(VueRouter);

const store = require('./store');
const routes = require('./Routes');
const scrollBehavior = require('./ScrollBehavior');
const data = require('../../../../../data/basic.json');
const elementsTracking = require('../../../viscomjs/analytics/elementsTracking');
const body = document.body;

export default new Vue({
    el: '#app',
    store,
    router: new VueRouter({
        routes,
        scrollBehavior
    }),
    data: {
        data: data
    },
    computed: {
        ...mapState('menu', {
            openState: state => state.open
        })
    },
    created() {
        // Setup scrollBehavior
        this.$router.options.scrollBehavior = scrollBehavior.bind(this.$router);

        if (!this.$router.currentRoute) {
            this.$router.push('/');
            return;
        }
        const cur = this.$router.currentRoute;
        if (this.checkRouteExistence(cur)) {
            this.updateDocState(cur);
            return;
        }

        if (cur.fullPath !== '/') this.$router.push('/404');
    },
    mounted() {
        elementsTracking.init(this.$el);
    },
    watch: {
        $route(to /* , from*/) {
            if (this.checkRouteExistence(to)) {
                this.updateDocState(to);

                this.closeMenu();
                return;
            }
            this.$router.push('/404');
        },
        openState(to) {
            if (to) body.dataset.menuOn = '1';
            else delete body.dataset.menuOn;
        }
    },
    methods: {
        checkRouteExistence(route) {
            return route.matched && route.matched.length > 0;
        },
        updateDocState(cur) {
            body.dataset.curRouteName = cur.name || '';
            body.dataset.curRouteId = cur.params.id || '';
            this.$store.dispatch('menu/select', cur.params);

            /* ie hack */
            if (cur.name === 'cover') {
                body.classList.remove('ie-hack');
            } else {
                body.classList.add('ie-hack');
            }
        },
        closeMenu() {
            this.$store.dispatch('menu/close');
        },
        afterLeave() {
            // console.log('triggerScroll');
            this.$root.$emit('triggerScroll');
        },
        goBack() {
            window.history.length > 1 ? this.$router.go(-1) : this.$router.push('/');
        }
    }
});
